'use strict';
namespace TR {

    class InsuranceSelection {

        private bookingLoaded: boolean;
        private captureInsurance: boolean;
        private defaultBandCostForType: any = {};
        private insurance: any;
        private insuranceConfirmation: boolean = false;
        private insuranceOptionId: string = '';
        private insuranceOptions: any[];
        private oneWay: boolean;
        private trip: any;

        public adultsWithInsurance: number = 0;
        public children: number = 0;
        public description: string;
        public insurees: any[] = [];
        public filteredInsurees: any[] = [];
        public userData: any;

        constructor(
            private $scope: ng.IScope,
            private basketService: any,
            private broker: any,
            private insuranceService: any,
            private $filter:any,
            private resourceService:any
        )
        {
            const ignoreRooms = $scope.$watch('is.bookingLoaded', b => {
                if(b) {
                    this.init();
                    ignoreRooms();
                }
            });
        }

        private init() {
            if (this.captureInsurance && this.insurance) {

                //fill our insurees list
                _.each(this.userData.Rooms, r => {
                    _.each(r.Guests, g => {
                        if (g.Type === 1) {
                            this.adultsWithInsurance++;
                        }
                            this.insurees.push(g);
                    });
                });

                if(!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands
                    && this.insuranceOptions && !_.some(this.insuranceOptions, io => io.Id === -1)){
                    //will have to find a better way to set this
                    this.insuranceOptions.push(
                        { Id:-1,
                        Label: this.resourceService.get('PLEASESELECT'),
                        PassengerType: 1}
                    );
                }

                this.basketService.getInsuranceQuotes(this.insurance.AvailabiltySearchId,
                                                        this.trip.BasketId,
                                                        this.trip.TripId,
                                                        { onewayOnly: this.oneWay }).then(insuranceQuotes => {

                    this.insuranceOptionId = this.insurance.Options[0].OptionId;
                    const optionKey = this.insuranceService.decomposeOptionId(this.insuranceOptionId);

                    const quote = _.find(insuranceQuotes, (q: any) => {
                        return q.SupplierId === optionKey.supplierId
                                && q.QuoteType.SchemeId === optionKey.schemeId
                                && q.QuoteType.TypeId === optionKey.typeId
                                && (q.QuoteType.RelationshipId === optionKey.relationshipId
                                                                || optionKey.relationshipId === 0);
                    });

                    this.description =
                            `${quote.QuoteType.Destination} ${quote.QuoteType.Scheme} ${quote.QuoteType.Type}`;
                });

                this.filteredInsurees = this.$filter('orderBy')(this.insurees,['Type','-Age'])
                .map(insuree => {
                     insuree.priceDifference = this.getPriceDifference(insuree);
                     insuree.passengerType = this.getPassengerType(insuree.Type);
                     insuree.price = this.getPrice(insuree);
                    if(!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands){
                        insuree.InsuranceBandId = -1;
                    }
                     return insuree;
                });
            };
        }

        private updateInsuranceBandSelections() {
            //if the insurance band price is 0 && it is an adult passenger treat it as not available
            const excludedBandIds = _.map(_.filter(this.insuranceOptions, { Available: false }), 'Id');

            let {childAges, adultAges} = _.reduce(
                    this.insurees,
                    (acc:any, person:any) => {
                            if (person.InsuranceBandId > 0
                                    && _.indexOf(excludedBandIds, person.InsuranceBandId) === -1) {
                                if (person.Type === 1) {
                                    acc.adultAges.push(person.InsuranceBandId);
                                } else {
                                    acc.childAges.push(person.InsuranceBandId);
                                }
                            }
                            return acc;
                    },
                    {childAges:[], adultAges:[]}
            );

            if (adultAges.length === 0 && childAges.length > 0) {
                //clear child insurance ages
                this.insurees.forEach(i => {
                    if (i.Type !== 1) {
                        i.InsuranceBandId = null;
                    }
                });
                childAges = [];
            }



            this.adultsWithInsurance = adultAges.length;
            return adultAges.concat(childAges);
        }

        getInsuranceLabel(guestId) {
            const i :any = _.find(this.insurees, { Id: guestId });

            return (i.Title && i.FirstName && i.LastName) ?
                        `${i.Title} ${i.FirstName} ${i.LastName}` : i.Label;
        }

        getPriceDifference(insuree) {

            const guestType = insuree.Type;
            const bandId = insuree.InsuranceBandId;

            //check to see if we have calculated this already
            if (!(this.defaultBandCostForType[guestType] && this.defaultBandCostForType[guestType][bandId])) {
                //find base (cheapest) options for this user type
                const defaultOption = _.first(_.filter(this.insuranceOptions, { 'PassengerType' : guestType }));

                const newPrice = bandId > 0 ? _.find(this.insuranceOptions, { Id: bandId }).Price : 0;

                if (!this.defaultBandCostForType[guestType]) {
                    this.defaultBandCostForType[guestType] = {};
                }
                this.defaultBandCostForType[guestType][bandId] = newPrice - defaultOption.Price;
            }
            return this.defaultBandCostForType[guestType][bandId];
        }

        getPrice(insuree) {
            return insuree && insuree.InsuranceBandId > 0 ?
            _.find(this.insuranceOptions, { Id: insuree.InsuranceBandId }).Price : 0;
        }

        updateInsuranceQuote(userData) {
            const ages = this.updateInsuranceBandSelections();

            this.filteredInsurees.map(insuree => {
                insuree.priceDifference = this.getPriceDifference(insuree);
                insuree.price = this.getPrice(insuree);
            });

            return this.basketService.updateInsuranceQuote(
                this.trip.BasketId, this.trip.TripId, this.insuranceOptionId, { oneWayOnly: this.oneWay, ages }
            ).then(() => {
                this.broker.publish('bookingBasketUpdated', angular.copy(userData));
                this.broker.publish('basketUpdated');
                return;
            });
        }

        getPassengerType(type) {
            if (type > 0) {
                switch (type) {
                    case Core.Booking.PassengerType.Adult:
                        return this.resourceService.get('ADULT');
                    case Core.Booking.PassengerType.Child:
                        return this.resourceService.get('CHILD');
                    case Core.Booking.PassengerType.Infant:
                        return this.resourceService.get('INFANT');
                }
            }
            return '';
        }

    }

    angular
        .module('TR')
        .directive('insuranceSelection', () => {
            return {
                bindToController: true,
                controller: InsuranceSelection,
                controllerAs: 'is',
                restrict: 'E',
                replace: true,
                scope: {
                    bookingLoaded: '=',
                    captureInsurance: '=',
                    insurance: '=',
                    insuranceOptions: '=',
                    oneWay: '=',
                    trip: '=',
                    userData: '='
                },
                templateUrl: (element,attr) => {
                    if(attr.templateVersion) {
                        return 'partials/booking/template?name=InsuranceSelection&version='
                        + attr.templateVersion;
                    } else {
                        return 'partials/home/directivetemplate?type=InsuranceSelection';
                    }
                }
            };
        });
}
